import React, { useContext } from "react";

// Material UI imports
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";

// Styling
import "./style.scss";

// Global state
import { StateContext } from "../../AppStateContext";

// schema add class state
import {
  SchemaAddClassStateContext,
  SchemaAddClassStateDispatchContext,
} from "./SchemaAddClassStateContext";

const AddClassFormClassDescription = () => {
  // Consume global state
  const state = useContext(StateContext);

  // consume add class state
  const schemaState = useContext(SchemaAddClassStateContext);
  const schemaSetState = useContext(SchemaAddClassStateDispatchContext);

  return (
    <div className="__schemaAddClassDescription">
      <label
        htmlFor="addClassDescriptionTextarea"
        className={
          state.theme === "dark"
            ? "__addClassFormTextColorDark"
            : "__addClassFormTextColorLight"
        }
      >
        Description
        <Tooltip
          placement="right-start"
          title="An optional description of the class to clarify the meaning, if the name does not covers it fully."
        >
          <HelpIcon
            style={{
              fontSize: "15px",
              color: state.theme === "dark" ? "#848484" : "#5e5e5e",
              cursor: "pointer",
              marginLeft: "6px",
            }}
          />
        </Tooltip>
      </label>
      <textarea
        className={
          state.theme === "dark"
            ? "__addClassFormTextareaDark"
            : "__addClassFormTextareaLight"
        }
        id="addClassDescriptionTextarea"
        cols="10"
        rows="3"
        value={schemaState.description}
        onChange={(e) =>
          schemaSetState({ ...schemaState, description: e.target.value })
        }
      />
    </div>
  );
};

export default AddClassFormClassDescription;
